// extracted by mini-css-extract-plugin
export default {"joyful-text":"LoadingOverlay_joyful-text__4yzov","joyful-pulse":"LoadingOverlay_joyful-pulse__oqpOI"};